<template>
  <b-modal ref="PinElement"
           :title="$t('ct-confirm-pin')"
           @close="close()"
           @hidden="close()"
           data-component="modal-bootstrap-vue"
           no-close-on-backdrop hide-footer>
    <div class="d-flex justify-content-between">
      <small class="alert-info text-center">{{ $t('ct-notmobile-pin') }}</small>
    </div>
    <div class="container row d-flex justify-content-center">
      <div class="row">
        <!-- <p class="alert-info text-center">{{$t('ct-warning-only-works-correctly-on-publicatio')}}</p> -->
        <div class="d-flex justify-content-between"
             v-tooltip="{content:$t('ct-manual-pin-explain'),  class: 'tooltip-custom'}">
          <button slot="button" class="btn btn btn-outline-info mt-2"
                  :class="{ 'active' : element !== null && element.internal_config.pinConfig.manual }" @click="manual">
            {{ $t('ct-manual-pin') }}
          </button>
        </div>
      </div>
      <small style="margin : 5px" class="alert-info text-center">{{ $t('ct-notmanual-pin') }}</small>
    </div>

    <div style="display: flex">
      <small style="justify-content: center" class="orborder text-center">{{ $t('ct-orborder-pin') }}</small>
    </div>
    <div class="">
      <div class="ConjBtn" v-tooltip="{content:$t('ct-border-pin'),  class: 'tooltip-custom'}">
        <div class="container"></div>
        <div class="d-flex row border  border-primary">
          <div class="col-4">
            <button id="bot-click-1" type="button" class="btn btn-outline-primary btnColor"
                    @click="border('top-left')"></button>
            <button id="bot-click-5" type="button" class="btn btn-outline-primary btnColor"
                    @click="border('mid-left')"></button>
            <button id="bot-click-7" type="button" class="btn btn-outline-primary btnColor"
                    @click="border('bottom-left')"></button>
          </div>
          <div class="col-4">
            <button id="bot-click-2" type="button" class="btn btn-outline-primary btnColor "
                    @click="border('top-mid')"></button>
            <button id="bot-click-4" type="button" class="btn btn-outline-primary btnColor "
                    @click="border('mid-mid')"></button>
            <button id="bot-click-8" type="button" class="btn btn-outline-primary btnColor "
                    @click="border('bottom-mid')"></button>
          </div>
          <div class="col-4">
            <button id="bot-click-3" type="button" class="btn btn-outline-primary btnColor "
                    @click="border('top-right')"></button>
            <button id="bot-click-6" type="button" class="btn btn-outline-primary btnColor "
                    @click="border('mid-right')"></button>
            <button id="bot-click-9" type="button" class="btn btn-outline-primary btnColor "
                    @click="border('bottom-right')"></button>
          </div>
        </div>
      </div>
    </div>
    <div class="text-center py-3">
      <button slot="button" class="btn btn-outline-danger" @click="remove()">
        {{ $t('ct-fix-remove') }}
      </button>
    </div>

    <p class="alert-info text-center">{{ $t('ct-warning-only-works-correctly-on-publicatio') }}</p>

    <div>
      <button style="left:50%;" slot="button" class="btn btn-primary confirm" @click="confirm()"
              data-ba-i="pin-item">{{ $t('ct-fix-yes') }}
      </button>
    </div>
  </b-modal>
</template>

<script>

export default {
  name: "ModalPin",
  props: ["text", "show", "values"],
  data() {
    return {
      element: null
    };
  },
  methods: {
    openModal() {
      this.$refs['PinElement'].show();
    },

    hideModal() {
      this.$refs['PinElement'].hide();
    },

    manual() {

      //todo manual fazer improve pra publicacao e preview, mas ta bão
      var pos = document.getElementById(this.element.id).getBoundingClientRect();
      this.element.internal_config.pinConfig.pin = true;
      this.element.internal_config.pinConfig.manual = true;
      this.element.internal_config.pinConfig.pTop = pos.top;
      this.element.internal_config.pinConfig.pLeft = pos.left;
      this.element.internal_config.pinConfig.position = "fixed";
      this.element.internal_config.zIndex = 30;
      this.element.internal_config.pinConfig.btnClick = null;


      //remove marcadores de seleção de borda
      $('.btnColor').css('background-color', '#ffff');
      this.$root.$emit("hidePinElement");

    },
    border(type) {

      this.element.internal_config.pinConfig.manual = false;

      // seta botão clicado para tratamento da caixa
      switch (type) {
        case "top-left":
          this.element.internal_config.pinConfig.btnClick = "#bot-click-1";
          break;

        case "top-mid":
          this.element.internal_config.pinConfig.btnClick = "#bot-click-2";
          break;

        case "top-right":
          this.element.internal_config.pinConfig.btnClick = "#bot-click-3";
          break;

        case "mid-mid":
          this.element.internal_config.pinConfig.btnClick = "#bot-click-4";
          break;

        case "mid-left":
          this.element.internal_config.pinConfig.btnClick = "#bot-click-5";
          break;

        case "mid-right":
          this.element.internal_config.pinConfig.btnClick = "#bot-click-6";
          break;

        case "bottom-left":
          this.element.internal_config.pinConfig.btnClick = "#bot-click-7";
          break;
        case "bottom-mid":
          this.element.internal_config.pinConfig.btnClick = "#bot-click-8";
          break;

        case "bottom-right":
          this.element.internal_config.pinConfig.btnClick = "#bot-click-9";
          break;
      }

      this.element.internal_config.pinConfig.type = type;
      this.element.internal_config.pinConfig.pin = true;

      //marcadores
      if (this.element.internal_config.pinConfig.btnClick == null) {
        $('.btnColor').css('background-color', '#ffff');
      } else {
        $('.btnColor').css('background-color', '#ffff');
        $(`${this.element.internal_config.pinConfig.btnClick}`).css('background-color', '#6495ED');
      }


    },
    remove() {
      let element = $(`#${this.element.id}`);
      const leftElement = $(element).offset().left;
      let _pai = $(element).parent();
      let _leftpai = ~~$(_pai).offset().left;
      let _topPai = ~~$(_pai).offset().top;
      let _topFilho = $(element).offset().top;

      element.css({
        position: "",
        top: `${_topFilho - _topPai}px`,
        left: `${leftElement - _leftpai}px`,
        right: ""
      });

      this.element.internal_config.pinConfig.position = 'relative';
      this.element.internal_config.pinConfig.pLeft = `${leftElement - _leftpai}px`;
      this.element.internal_config.pinConfig.pTop = `${_topFilho - _topPai}px`;
      this.element.internal_config.pinConfig.btnClick = null;
      this.element.internal_config.pinConfig.manual = false;
      this.element.internal_config.pinConfig.type = "";
      this.element.internal_config.pinConfig.pin = false;

      //remove marcadores de seleção de borda
      $('.btnColor').css('background-color', '#ffff');

      this.$root.$emit("hidePinElement");

    },

    confirm() {

      var elemento = document.getElementById(this.element.id);
      let _pai = document.getElementById('editor-content')
      let _widthpai = _pai.offsetWidth;
      let _heightpai = window.innerHeight;
      let _toppai = ~~$(_pai).offset().top;
      let _leftpai = ~~$(_pai).offset().left;
      let _topElem = ~~$(elemento).offset().top;
      let _leftElem = ~~$(elemento).offset().left;
      let _widthfilho = $(elemento).children().width();
      let _heightfilho = $(elemento).children().height();
      let element = $(`#${this.element.id}`); // variavel para setar o css no elemento correto

      if (this.element.internal_config.pinConfig.pin == false) {
        this.$root.$emit("hidePinElement");
        return 0;
      }

      //Compara e seta posição de fixado
      switch (this.element.internal_config.pinConfig.type) {

        case "top-left":

          //Configura css
          element.css({
            position: "fixed",
            left: `${_leftpai}px`,
            top: 75,
          });

          //Atualiza o model para enviar para a publicação
          this.element.internal_config.pinConfig.pTop = 75;
          this.element.internal_config.pinConfig.pLeft = `${_leftpai}px`;
          this.element.internal_config.pinConfig.btnClick = "#bot-click-1";
          break;

        case "top-mid":

          element.css({
            position: "fixed",
            top: 75,
            left: `${_widthpai / 2 - _widthfilho / 2}px`,
            right: "",
          });

          this.element.internal_config.pinConfig.pTop = 75;
          this.element.internal_config.pinConfig.pLeft = `${_widthpai / 2 - _widthfilho / 2}px`;
          this.element.internal_config.pinConfig.btnClick = "#bot-click-2";
          break;

        case "top-right":

          element.css({
            position: "fixed",
            top: 75,
            left: `${_widthpai - _widthfilho}px`,
            right: ""
          });

          this.element.internal_config.pinConfig.pTop = 75;
          this.element.internal_config.pinConfig.pLeft = `${_widthpai - _widthfilho}px`;
          this.element.internal_config.pinConfig.btnClick = "#bot-click-3";
          break;

        case "mid-mid":

          element.css({
            position: "fixed",
            top: _heightpai / 2 - _heightfilho / 2,
            left: `${_widthpai / 2 - _widthfilho / 2}px`,
            right: ""
          });

          this.element.internal_config.pinConfig.pTop = `${_heightpai / 2 - _heightfilho / 2}px`;
          this.element.internal_config.pinConfig.pLeft = `${_widthpai / 2 - _widthfilho / 2}px`;
          this.element.internal_config.pinConfig.btnClick = "#bot-click-4";
          break;

        case "mid-left":

          element.css({
            position: "fixed",
            top: _heightpai / 2 - _heightfilho / 2,
            left: _leftpai,
            right: ""
          });

          this.element.internal_config.pinConfig.pTop = `${_heightpai / 2 - _heightfilho / 2}px`;
          this.element.internal_config.pinConfig.pLeft = `${_leftpai}px`;
          this.element.internal_config.pinConfig.btnClick = "#bot-click-5";
          break;

        case "mid-right":

          element.css({
            position: "fixed",
            top: `${_heightpai / 2 - _heightfilho / 2}px`,
            left: `${_widthpai - _widthfilho}px`,
            right: ""
          });

          this.element.internal_config.pinConfig.pTop = `${_heightpai / 2 - _heightfilho / 2}px`;
          this.element.internal_config.pinConfig.pLeft = `${_widthpai - _widthfilho}px`;
          this.element.internal_config.pinConfig.btnClick = "#bot-click-6";
          break;

        case "bottom-left":

          element.css({
            position: "fixed",
            top: _heightpai - _heightfilho,
            left: _leftpai,
            right: "",
          });

          this.element.internal_config.pinConfig.pTop = _heightpai - _heightfilho;
          this.element.internal_config.pinConfig.pLeft = `${_leftpai}px`;
          this.element.internal_config.pinConfig.btnClick = "#bot-click-7";
          break;
        case "bottom-mid":

          element.css({
            position: "fixed",
            top: _heightpai - _heightfilho,
            left: `${_widthpai / 2 - _widthfilho / 2}px`,
            right: ""
          });

          this.element.internal_config.pinConfig.pTop = _heightpai - _heightfilho;
          this.element.internal_config.pinConfig.pLeft = `${_widthpai / 2 - _widthfilho / 2}px`;
          this.element.internal_config.pinConfig.btnClick = "#bot-click-8";
          break;

        case "bottom-right":

          element.css({
            position: "fixed",
            top: _heightpai - _heightfilho,
            left: `${_widthpai - _widthfilho}px`,
            right: ""
          });

          this.element.internal_config.pinConfig.pTop = _heightpai - _heightfilho;
          this.element.internal_config.pinConfig.pLeft = `${_widthpai - _widthfilho}px`;
          this.element.internal_config.pinConfig.btnClick = "#bot-click-9";
          break;
      }

      this.element.internal_config.pinConfig.position = "fixed";
      this.element.internal_config.pinConfig.pin = true;
      this.element.internal_config.pinConfig.manual = false;
      this.element.internal_config.zIndex = 30;


      this.$root.$emit("hidePinElement");
    },

    close() {
      if (this.element.internal_config.pinConfig.pin) {
        this.$root.$emit("hidePinElement");
      } else {

        this.element.internal_config.pinConfig.btnClick = null;
        $('.btnColor').css('background-color', '#ffff');
        this.$root.$emit("hidePinElement");

      }
    },
    setValues(elem) {
      this.element = elem;
    }

  },

  mounted() {
    if (this.element) {
      if (this.element.internal_config.pinConfig.btnClick == null) {
        $('.btnColor').css('background-color', '#ffff');
      } else {
        $('.btnColor').css('background-color', '#ffff');
        $(`${this.element.internal_config.pinConfig.btnClick}`).css('background-color', '#6495ED');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.border {
  margin-left: auto;
  margin-right: auto;
  padding: 4px;
  width: 270px;
  border: 5px solid #007bff !important;
  height: 163px;
  border-radius: 10px 10px;
  display: flex;
}

.col-4 {
  margin-left: auto;
  margin-right: auto;
  padding-right: 0px;
  padding-left: 0px;
  justify-content: center;
}

.orborder {
  margin-left: auto;
  margin-right: auto;
  position: relative;
}

.confirm {
  float: right;
}

.btn-outline-primary {
  width: 90% !important;
  height: 32px;
  margin-bottom: 4px !important;
  margin-top: 4px !important;
  margin-left: 2.5%;
  margin-right: 2.5%;
}

.container {
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 5px;
  margin-top: 5px;
  min-width: 300px;
}

.sweet-modal {
  width: 34%;
}

.tooltip-custom {
  z-index: 30;
}
</style>



// WEBPACK FOOTER //
// src/components/editor/base/Pin.vue